var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFog(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "fog",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    enableBackground: "new 0 0 24 24",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    width: 24,
    height: 24
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 11.9998,
    y1: 16.0002,
    x2: 11.9998,
    y2: 2.0003
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "url(#SVGID_1_)",
    d: "M10.9998,2.0003c-3.866,0-7,3.132-7,7.0001 c0,0.2499,0.015,0.4959,0.04,0.738c-1.194,0.4789-2.04,1.644-2.04,3.012c0,1.793,1.455,3.2499,3.25,3.2499h12.4 c2.403,0,4.35-1.9489,4.35-4.35c0-2.3569-1.875-4.263-4.213-4.337C17.0318,4.2633,14.2838,2.0003,10.9998,2.0003z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 11.9998,
    y1: 16.0002,
    x2: 11.9998,
    y2: 2.0003
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    style: {
      stopColor: "#1D1D33",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    style: {
      stopColor: "#1D1D33"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_2_)",
    d: "M10.9998,3.0003c2.7609,0,5.1527,1.8724,5.8163,4.5533l0.182,0.7352l0.7571,0.024 c1.8194,0.0576,3.2446,1.5236,3.2446,3.3375c0,1.8472-1.5028,3.35-3.35,3.35h-12.4c-1.2407,0-2.25-1.0093-2.25-2.2499 c0-0.9218,0.5544-1.7397,1.4123-2.0839l0.6999-0.2807L5.0345,9.6356C5.0111,9.4094,4.9998,9.2015,4.9998,9.0004 C4.9998,5.6919,7.6914,3.0003,10.9998,3.0003 M10.9998,2.0003c-3.866,0-7,3.132-7,7.0001c0,0.2499,0.015,0.4958,0.04,0.738 c-1.194,0.4789-2.04,1.644-2.04,3.012c0,1.793,1.455,3.2499,3.25,3.2499h12.4c2.403,0,4.35-1.949,4.35-4.35 c0-2.3569-1.875-4.263-4.213-4.337C17.0318,4.2634,14.2838,2.0003,10.9998,2.0003L10.9998,2.0003z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#D5DEE8",
    d: "M11.9968,21.8592c-2.577,0-3.886-0.4191-5.151-0.823 c-1.247-0.4001-2.425-0.777-4.846-0.777c-0.276,0-0.5-0.223-0.5-0.4999c0-0.276,0.224-0.5001,0.5-0.5001 c2.578,0,3.886,0.4191,5.151,0.8241c1.247,0.399,2.425,0.7759,4.846,0.7759c2.423,0,3.601-0.3769,4.849-0.7759 c1.266-0.405,2.575-0.8241,5.154-0.8241c0.277,0,0.5,0.2241,0.5,0.5001c0,0.2769-0.223,0.4999-0.5,0.4999 c-2.422,0-3.601,0.3769-4.849,0.777C15.8848,21.4401,14.5758,21.8592,11.9968,21.8592 M11.9968,15.8592 c-2.577,0-3.886-0.4191-5.151-0.823c-1.247-0.4001-2.425-0.777-4.846-0.777c-0.276,0-0.5-0.223-0.5-0.4999 c0-0.276,0.224-0.5001,0.5-0.5001c2.578,0,3.886,0.4191,5.151,0.8241c1.247,0.399,2.425,0.7759,4.846,0.7759 c2.423,0,3.601-0.3769,4.849-0.7759c1.266-0.405,2.575-0.8241,5.154-0.8241c0.277,0,0.5,0.2241,0.5,0.5001 c0,0.2769-0.223,0.4999-0.5,0.4999c-2.422,0-3.601,0.3769-4.849,0.777C15.8848,15.4401,14.5758,15.8592,11.9968,15.8592  M11.9968,18.8592c-2.577,0-3.886-0.4191-5.151-0.823c-1.247-0.4001-2.425-0.777-4.846-0.777c-0.276,0-0.5-0.223-0.5-0.4999 c0-0.276,0.224-0.5001,0.5-0.5001c2.578,0,3.886,0.4191,5.151,0.8241c1.247,0.399,2.425,0.7759,4.846,0.7759 c2.423,0,3.601-0.3769,4.849-0.7759c1.266-0.405,2.575-0.8241,5.154-0.8241c0.277,0,0.5,0.2241,0.5,0.5001 c0,0.2769-0.223,0.4999-0.5,0.4999c-2.422,0-3.601,0.3769-4.849,0.777C15.8848,18.4401,14.5758,18.8592,11.9968,18.8592"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFog);
export default __webpack_public_path__ + "static/media/fog.e75170b4eedf934bba20305cc4310926.svg";
export { ForwardRef as ReactComponent };